

















































































































































































































/*
  saveOrUpdate 保存或编辑教师信息
*/
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Form as ElForm } from "element-ui";
import { validateMax32, validateAge, validateTeacherAge, blurTeacherAge, ruleNormal, rulePattern,validatePhone } from '@/utils/regxCustom'
import {
  saveOrUpdate
} from "../../../../api/teacherMaintain";
import {
  computedDate
} from "../../../../utils/common";

@Component({
  name: "teacherInfoManageDetail"
})
export default class extends Vue {
  @Prop(String) type!: string;
  @Prop(Object) private teacherInfo!: {
    // otherinfoSourceId: "";
    // otherinfoProjectId: "";
    teacherName: "";
    teacherGenderId: "";
    teacherCard: "";
    teacherBirthday: "";
    teacherAge: "";
    teacherProfessionalId: "";
    teacherTeachingAge: "";
    teacherGradeId: "";
    // otherinfoSubject: "";
    teacherPhone: "";
    teacherDistrictId: "";
    teacherSchoolId: "";
    teacherIsBlacklist?: number;
    // otherinfoIsRecommendValue: "";
    // otherinfoIsRecommend: "";
  };

  private fullscreenLoading: boolean = false; //spin toggle

  private editForm: any = {};

  /** 黑名单教师（仅编辑时由列表行带入） */
  get isBlacklistTeacher(): boolean {
    return (
      this.type === "modify" &&
      Number((this.teacherInfo as any).teacherIsBlacklist) === 1
    );
  }

  private dialogFormTitle: string = ""; //弹窗标题
  private editFormRules: object = {
    otherinfoSourceId: [ruleNormal("请选择来源")],
    otherinfoProjectId: [ruleNormal("请选择项目")],
    teacherName: [
      ruleNormal("请输入姓名"),
      { validator: validateMax32}
    ],
    // teacherGenderId: [ruleNormal("请选择性别")],
    teacherCard: [
      ruleNormal("请输入身份证号")
    ],
    // teacherBirthday: [ruleNormal("请选择出生日期")],
    teacherAge: [
      ruleNormal("请输入年龄"),
      { validator: validateAge }
    ],
    // teacherProfessionalId: [ruleNormal("请选择职称")],
     teacherTeachingAge: [
      ruleNormal("请输入教龄"),
      { validator: validateTeacherAge },
      { validator: blurTeacherAge, trigger: "blur" }
    ],
    // teacherGradeId: [ruleNormal("请选择任课年级")],
    otherinfoSubject: [ruleNormal("请选择科目")], // 这里有问题
     teacherPhone: [
      ruleNormal("请输入手机号码"),
      //  { validator: validatePhone }
    ],
    teacherDistrictId: [ruleNormal("请选择所属市县")],
    teacherSchoolId: [ruleNormal("请选择所属单位")],
    otherinfoIsRecommendValue: [ruleNormal("请选择是否推荐")]
  };

  created() {
    if (this.type === "add") {
      this.dialogFormTitle = "添加教师";
    } else if (this.type === "modify") {
      this.dialogFormTitle = "编辑教师信息";
    }

    // 调试日志（生产环境可删除）
    console.log('[edit.vue created] teacherInfo:', this.teacherInfo);
    console.log('[edit.vue created] editForm:', this.editForm);
    const schools = (this.$parent as any).schools;
    console.log('[edit.vue created] $parent.schools:', schools ? schools.length : 0);
  }

  // 根据是否推荐显示value，但是传给后台传递数字
  private ifRecommend(e) {
    this.editForm[`otherinfoIsRecommend`] = e;
    this.editForm[`otherinfoIsRecommendValue`] = e == "0" ? "是" : "否";
  }

  // 根据选择的市县过滤单位列表
  get filteredSchools(): any[] {
    const schools = (this.$parent as any).schools || [];
    if (!this.editForm[`teacherDistrictId`]) {
      return schools;
    }
    // 使用宽松相等 == 避免字符串/数字类型不匹配问题（与 teacherInfoManage 保持一致）
    const filtered = schools.filter((school: any) => school.schoolDistrictId == this.editForm[`teacherDistrictId`]);

    // 调试日志（生产环境可删除）
    console.log('[filteredSchools] teacherDistrictId:', this.editForm[`teacherDistrictId`], typeof this.editForm[`teacherDistrictId`]);
    console.log('[filteredSchools] schools 总数:', schools.length, '过滤后:', filtered.length);
    if (schools.length > 0) {
      console.log('[filteredSchools] 第一个 school.schoolDistrictId:', schools[0].schoolDistrictId, typeof schools[0].schoolDistrictId);
    }

    return filtered;
  }

  // 市县变更时清空单位选择
  private handleDistrictChange() {
    this.editForm[`teacherSchoolId`] = '';
  }

  // 监听 teacherInfo 变化，同步更新 editForm
  @Watch("teacherInfo", { immediate: true, deep: true })
  private onTeacherInfoChange(val: any) {
    if (val) {
      this.editForm = {
        teacherName: val.teacherName || "",
        teacherGenderId: val.teacherGenderId || "",
        teacherCard: val.teacherCard || "",
        teacherBirthday: val.teacherBirthday || "",
        teacherAge: val.teacherAge || "",
        teacherProfessionalId: val.teacherProfessionalId || "",
        teacherTeachingAge: val.teacherTeachingAge || "",
        teacherGradeId: val.teacherGradeId || "",
        teacherPhone: val.teacherPhone || "",
        teacherDistrictId: val.teacherDistrictId || "",
        teacherSchoolId: val.teacherSchoolId || "",
      };
      // 调试日志：检查 districts 和 teacherDistrictId 的值
      console.log('[edit.vue @Watch] teacherDistrictId:', val.teacherDistrictId, typeof val.teacherDistrictId);
      console.log('[edit.vue @Watch] districts:', (this.$parent as any).districts);
    }
  }
  // form 表单正则之外的校验 res = {age:'', bornDate:'',gender:''} 1 男 2 女

  // private async handleID(val) {
  //   let data = await getTeacherInfoByCardId(val); //输入完身份证，通过格式校验发送请求获取当前身份证用户的信息
  //   if (data.data) {
  //     // 弹窗提示黑名单用户是否继续添加，取消则隐藏弹窗
  //     if (data.data[`teacherIsBlacklist`] == "1") {
  //       this.$confirm('此教师在黑名单中, 是否继续?', '提示', {
  //         confirmButtonText: '确定',
  //         cancelButtonText: '取消',
  //         type: 'warning'
  //       }).then(() => {}).catch(() => {
  //         (this.$parent as any).dialogFormVisible = false;  //取消则隐藏弹窗
  //         this.$message({
  //           type: 'info',
  //           message: '已取消添加'
  //         });
  //       });
  //     }
  //     //如果存在则自动填充
  //     this.editForm[`teacherName`] = data.data[`teacherName`];
  //     this.editForm[`teacherAge`] = data.data[`teacherAge`];
  //     this.editForm[`teacherName`] = data.data[`teacherName`];
  //     this.editForm[`teacherProfessionalId`] =
  //       data.data[`teacherProfessionalId`];
  //     this.editForm[`teacherTeachingAge`] = data.data[`teacherTeachingAge`];
  //     this.editForm[`teacherGradeId`] = data.data[`teacherGradeId`];
  //     this.editForm[`teacherPhone`] = data.data[`teacherPhone`];
  //     this.editForm[`teacherSchoolId`] = data.data[`teacherSchoolId`];
  //   } else {
  //     //如果删除身份证号码则清空其他数据(除了 来源 项目 科目 身份证号)
  //     for (let key in this.editForm) {
  //       if (
  //         key === "teacherCard" ||
  //         key === "otherinfoSourceId" ||
  //         key === "otherinfoProjectId" ||
  //         key === "otherinfoSubject"
  //       ) {
  //         continue;
  //       }
  //       this.editForm[key] = "";
  //     }
  //   }
  //   // 格式校验
  //   let IDReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  //   let res = computedDate(val);
  //   if (!IDReg.test(val)) {
  //     this.$message.warning("请检查身份证号码是否有误！");
  //   } else {
  //     if (
  //       this.editForm[`teacherGenderId`] &&
  //       this.editForm[`teacherGenderId`] != res.gender
  //     ) {
  //       this.$message.warning("请检查性别和身份证号码是否一致！");
  //     }

  //     this.editForm[`teacherGenderId`] = res.gender;
  //     if (
  //       this.editForm[`teacherBirthday`] &&
  //       this.editForm[`teacherBirthday`] != res.bornDate
  //     ) {
  //       this.$message.warning("请检查出生日期和身份证号码是否一致！");
  //     }
  //     this.editForm[`teacherBirthday`] = res.bornDate;

  //     if (
  //       this.editForm[`teacherAge`] &&
  //       this.editForm[`teacherAge`] != res.age
  //     ) {
  //       this.$message.warning("请检查年龄和身份证号码是否一致！");
  //     }
  //     this.editForm[`teacherAge`] = res.age;
  //   }
  //   this.$forceUpdate();
  // }

  // // 性别
  // private handleGender(val) {
  //   let IDReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  //   if (
  //     this.editForm[`teacherGenderId`] &&
  //     IDReg.test(this.editForm[`teacherCard`])
  //   ) {
  //     let res = computedDate(this.editForm[`teacherCard`]);
  //     this.editForm[`teacherGenderId`] != res.gender
  //       ? this.$message.warning("请检查性别和身份证号是否一致！")
  //       : "";
  //     this.editForm[`teacherGenderId`] = val;
  //   }
  //   this.$forceUpdate();
  // }
  // // 出生日期
  // private handleBirthday(val) {
  //   let IDReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  //   if (
  //     this.editForm[`teacherBirthday`] &&
  //     IDReg.test(this.editForm[`teacherCard`])
  //   ) {
  //     let res = computedDate(this.editForm[`teacherCard`]);
  //     this.editForm[`teacherBirthday`] != res.bornDate
  //       ? this.$message.warning("请检查生日和身份证号是否一致！")
  //       : "";
  //     this.editForm[`teacherBirthday`] = val;
  //   }
  //   this.$forceUpdate();
  // }

  // 年级
  private handleAge(val) {
    let IDReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (
      this.editForm[`teacherAge`] &&
      IDReg.test(this.editForm[`teacherCard`])
    ) {
      let res = computedDate(this.editForm[`teacherCard`]);
      this.editForm[`teacherAge`] != res.age
        ? this.$message.warning("请检查年龄和身份证号是否一致！")
        : "";
      this.editForm[`teacherAge`] = val;
    }
    this.editForm[`teacherAge`] = val;
    this.$forceUpdate();
  }

  // 保存或编辑
  private saveEditHandle() {
    (this.$refs.editForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        if (this.isBlacklistTeacher) {
          try {
            await this.$confirm(
              "该教师仍在黑名单中，保存后仍无法参加审核、选拔与聘用；请先移出黑名单。是否仍保存本次基础信息修改？",
              "提示",
              { type: "warning", confirmButtonText: "仍保存", cancelButtonText: "取消" }
            );
          } catch (e) {
            return;
          }
        }
        try {
          this.fullscreenLoading = true;
          let res = await saveOrUpdate(this.editForm)
          this.fullscreenLoading = false;
          this.$message.success("保存成功");
          //关闭弹窗
          (this.$parent as any).dialogFormVisible = false;
          //刷新列表
          (this.$parent as any).getData();
          (this.$refs.editForm as ElForm).clearValidate();
        } catch (error) {
          this.fullscreenLoading = false;
          // this.$message.error(error || "保存失败");
          this[`$message`]({
            type: "error",
            message: error!.mesg ? error!.mesg : error
          });
        }
      }
    });
  }

  // 取消
  private handleCancel() {
    (this.$refs.editForm as ElForm).clearValidate();
    (this.$parent as any).dialogFormVisible = false;
  }
}
